import { memo } from "react";
import AdditionalChargeVesselTablePanel from "./Table/AdditionalChargeVesselTablePanel";

const AdditionalChargeVesselContent: React.FC = () => {
        return <div className={`main-comp-wrapper`} style={{ width: "60vw", height: "71vh" }}>
                <AdditionalChargeVesselTablePanel />
        </div>
}

export default memo(AdditionalChargeVesselContent);